import { useSnackbar } from 'notistack'
import React, { FC, useState } from 'react'
import { MarkupPropsType } from '../../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../../common/Helpers'
import MarkupUIBox from './MarkupUIBox'

interface IProps {
    addMarkup(markupProps: MarkupPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const DefineMarkup: FC<IProps> = (props) => {
    const [name, setName] = useState('')
    const [value, setValue] = useState('')

    const { enqueueSnackbar } = useSnackbar()

    const handleNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setName(event.target.value.replace(/['"]/, ''))
    }

    const handleValueChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setValue(event.target.value as string)
    }

    const handleCreateClick = () => {
        if (name === '') {
            showMessage(enqueueSnackbar, "Enter markup name")
            return
        }

        if (value === '') {
            showMessage(enqueueSnackbar, "Enter markup value")
            return
        }


        const markupProps = {
            name,
            value: parseFloat(value)
            // editable: markup.editable
        } as MarkupPropsType

        props.addMarkup(markupProps, enqueueSnackbar)

        setName('')
        setValue('')
    }

    return (
        <MarkupUIBox
            title='New Markup'
            name={{
                value: name,
                onChange: handleNameChange
            }}
            value={{
                value: value,
                onChange: handleValueChange
            }}

            button={{
                text: 'Create',
                onClick: handleCreateClick
            }}

        // editable
        />
    )
}

export default DefineMarkup